import { render, staticRenderFns } from "./WasteStatusPill.vue?vue&type=template&id=683de9a8&scoped=true&"
import script from "./WasteStatusPill.vue?vue&type=script&lang=js&"
export * from "./WasteStatusPill.vue?vue&type=script&lang=js&"
import style0 from "./WasteStatusPill.vue?vue&type=style&index=0&id=683de9a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683de9a8",
  null
  
)

export default component.exports